import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filterlist',
  templateUrl: './filterlist.component.html',
  styleUrls: ['./filterlist.component.css']
})
export class FilterlistComponent implements OnInit {


  @Input() filterstatus: string = "ALL";
  @Input() filterempid: any = 0;
  @Input() filterempname: string = "";
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() filterbonustypeid: any = 0;
  @Input() filterbonustypename: string = "";
  @Input() filterfinetypeid: any = 0;
  @Input() filterfinetypename: string = "";
  @Input() filterloantypeid = 0;
  @Input() filterloantypename = "";
  @Input() filterreimbursetypeid = 0;
  @Input() filterreimbursetypename = "";
  @Input() filterrequesttypeid = 0;
  @Input() filterrequesttypename = "";
  @Input() filtercontracttypeid = 0;
  @Input() filtercontracttypename = "";
  @Input() filterincidenttypeid = 0;
  @Input() filterincidenttypename = "";
  @Input() filterbranchid = 0;
  @Input() filterbranchname = "";
  @Input() filterrelievetypeid = 0;
  @Input() filterrelievetypename = "";
  @Input() filterdoctypeid = 0;
  @Input() filterdoctypename = "";
 
  @Input() filterpaymentstatus: string = "";

  @Input() formname: string = "";


  @Output() cbapplyChanged = new EventEmitter();
  @Output() filterChanged = new EventEmitter<number>();

  statusColl: any = [];


  constructor() { }


  ngOnInit() {
    this.fngetStatus();
  }


  fngetStatus() {
    this.statusColl.push({ displayname: "Active", value: "" });
    this.statusColl.push({ displayname: "InActive", value: "INACTIVE" });
    this.statusColl.push({ displayname: "All", value: "ALL" });
  }

  fnApplyFilter() {

    var _data = {
      status: this.filterstatus
    }

    this.cbapplyChanged.emit(_data);

  }

  fnRemoveFilter(type) {

    if (type === "EMPLOYEE") {
      this.filterempid = 0;
      this.filterempname = "";
    }
    else if (type === "FROMDATE") {
      this.filterfromdate = null;
    }
    else if (type === "TODATE") {
      this.filtertodate = null;
    }
    else if (type === "BONUSTYPE") {
      this.filterbonustypeid = 0;
      this.filterbonustypename = "";
    }
    else if (type === "FINETYPE") {
      this.filterfinetypeid = 0;
      this.filterfinetypename = "";
    }
    else if (type === "LOANTYPE") {
      this.filterloantypeid = 0;
     this.filterloantypename = "";
    }
    else if (type === "REIMBURSETYPE") {
      this.filterreimbursetypeid = 0;
      this.filterreimbursetypename = "";
    }
    else if (type === "REQUESTTYPE") {
      this.filterrequesttypeid = 0;
       this.filterrequesttypename = "";
    }
    else if (type === "CONTRACTTYPE") {
      this.filtercontracttypeid = 0;
       this.filtercontracttypename = "";
    }
    else if (type === "INCIDENTTYPE") {
      this.filterincidenttypeid = 0;
       this.filterincidenttypename = "";
    }
    else if (type === "BRANCH") {
      this.filterbranchid = 0;
       this.filterbranchname = "";
    }
    else if (type === "PAYMENTSTATUS") {
      this.filterpaymentstatus = null;
    }
    else if (type === "RELIEVETYPE") {
      this.filterrelievetypeid = 0;
       this.filterrelievetypename = "";
    }
    else if (type === "DOCTYPE") {
      this.filterdoctypeid = 0;
       this.filterdoctypename = "";
    }
    else {
      this.filterempid = 0;
      this.filterempname = "";
      this.filterfromdate = null;
      this.filtertodate = null;
      this.filterbonustypeid = 0;
      this.filterbonustypename = "";
      this.filterfinetypeid = 0;
      this.filterfinetypename = "";
      this.filterloantypeid = 0;
     this.filterloantypename = "";
       this.filterreimbursetypeid = 0;
      this.filterreimbursetypename = "";
      this.filterrequesttypeid = 0;
       this.filterrequesttypename = "";
       this.filtercontracttypeid = 0;
       this.filtercontracttypename = "";
       this.filterincidenttypeid = 0;
       this.filterincidenttypename = "";
      this.filterbranchid = 0;
      this.filterbranchname = "";
      this.filterrelievetypeid = 0;
      this.filterrelievetypename = "";
      this.filterpaymentstatus = "";
      this.filterdoctypeid = 0;
      this.filterdoctypename = "";
    }



    var _data = {
      empid: this.filterempid,
      empname: this.filterempname,
      fromdate: this.filterfromdate,
      todate: this.filtertodate,
      bonustypeid: this.filterbonustypeid,
      bonustypename: this.filterbonustypename,
      finetypeid: this.filterfinetypeid,
      finetypename: this.filterfinetypename,
      loantypeid: this.filterloantypeid,
      loantype: this.filterloantypename,
      reimbursetypeid: this.filterreimbursetypeid,
      reimbursetypename: this.filterreimbursetypename,
      requesttypeid: this.filterrequesttypeid,
      requesttypename: this.filterrequesttypename,
      contracttypeid:this.filtercontracttypeid ,
      contracttypename:this.filtercontracttypename ,
      incidenttypeid:this.filterincidenttypeid ,
      incidenttypename:this.filterincidenttypename ,
      branchid:this.filterbranchid ,
      branchname:this.filterbranchname ,
      relievetypeid:this.filterrelievetypeid,
      relievetypename:this.filterrelievetypename,
      paymentstatus:this.filterpaymentstatus,
      doctypeid:this.filterdoctypeid,
      doctypename:this.filterdoctypename,
    }

    this.cbapplyChanged.emit(_data);
  }

}
